export const handleDownload = (file) => {
    if (file && file.blobFile) {
        const url = file?.file ? file.file : URL.createObjectURL(file.blobFile);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    } else if (file?.file) {
        handleDownloadS3(file);
    }
};

const handleDownloadS3 = async (file) => {
    try {
        const response = await fetch(file.file);
        if (!response.ok) {
            throw new Error('Error al descargar el archivo');
        }
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = file.filename;
        link.click();
    } catch (error) {
        console.error('Error:', error);
    }
};
